import { render, staticRenderFns } from "./AtopicDermatitisHypothesisPhase.vue?vue&type=template&id=59d9c1cf&scoped=true&"
import script from "./AtopicDermatitisHypothesisPhase.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisHypothesisPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d9c1cf",
  null
  
)

export default component.exports